"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var BillPaymentLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(BillPaymentLineResource, _super);
    function BillPaymentLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillPaymentLineResource.endpoint = '/lines/bp';
    BillPaymentLineResource.MODEL_NAME = 'billpaymentline';
    return BillPaymentLineResource;
}(lines_1.BaseLineResource));
exports.default = BillPaymentLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/bp/lines.js
// module id = nVsY
// module chunks = 0